import apiClient from './config';

export default {
  // ===== CATÉGORIES =====

  // Récupérer toutes les catégories
  getAllCategories() {
    return apiClient.get('/categorie/gestion_services');
  },

  // Récupérer une catégorie par ID
  getCategoryById(id) {
    return apiClient.get(`/categorie/${id}`);
  },

  // Créer une nouvelle catégorie
  createCategory(data) {
    return apiClient.post('/categorie/gestion_services', data);
  },

  // Mettre à jour une catégorie
  updateCategory(id, data) {
    return apiClient.put(`/categorie/${id}`, data);
  },

  // Supprimer une catégorie
  deleteCategory(id) {
    return apiClient.delete(`/categorie/supprimer/${id}`);
  },

  // ===== SERVICES =====

  // Récupérer tous les services
  getAllServices() {
    return apiClient.get('/service/gestion_service');
  },

  // Récupérer un service par ID
  getServiceById(id) {
    return apiClient.get(`/service/${id}`);
  },

  // Créer un nouveau service
  createService(data) {
    return apiClient.post('/service/gestion_service', data);
  },

  // Mettre à jour un service
  updateService(id, data) {
    return apiClient.put(`/service/edit/${id}`, data);
  },

  // Supprimer un service
  deleteService(id) {
    return apiClient.delete(`/service/supprimer/${id}`);
  },

  // Récupérer les services par catégorie
  getServicesByCategory(categoryId) {
    return apiClient.get(`/service/categorie/${categoryId}`);
  },

  // Récupérer le catalogue complet (catégories + services)
  getCatalog() {
    return apiClient.get('/firm/catalog');
  },
};
